export type Stat = {
  title: string
  subtext: string
  slug: string
}

export const heroStats: Stat[] = [
  {
    title: '92%',
    subtext: 'placement rate',
    slug: 'placement'
  },
  {
    title: '5k +',
    subtext: 'matches made',
    slug: 'matches'
  },
  {
    title: '10k +',
    subtext: 'tech jobs available',
    slug: 'jobs'
  },
  {
    title: '8k +',
    subtext: 'job seekers',
    slug: 'seekers'
  }
]

export const programStats: Stat[] = [
  {
    title: '10k +',
    subtext: 'total students',
    slug: 'students'
  },
  {
    title: '60+',
    subtext: 'hiring partners',
    slug: 'partners'
  },
  {
    title: '92%',
    subtext: 'placement rate',
    slug: 'placement'
  }
]
